import { createSelector } from 'reselect';

const selectCustomer = state => state.customer;

export const selectCurrentCustomer = createSelector(
  [selectCustomer],
  customer => customer
);

